(function (app) {

    app.constant("taxFilingStatuses",
        [
            { ShortName: "Single", LongName: "Single" },
            { ShortName: "MarriedFilingJointly", LongName: "Married Filing Jointly" },
            { ShortName: "MarriedFilingSeparately", LongName: "Married Filing Separately" },
            { ShortName: "HeadofHousehold", LongName: "Head of Household" },
            { ShortName: "QualifyingWidow", LongName: "Qualifying Widow" }
        ]);

})(window.app); //jshint ignore:line